import { notification, SelectProps } from "antd";
import { makeAutoObservable } from "mobx";
import { onError } from "src/common/onError";
import { rest } from "src/common/rest";
import { ZDictGroup, zDictGroup } from "src/types/ZGroup";
import { apiObjUrl } from "src/common/apiUrl";
import { t } from "i18next";
import { ZUid } from "src/types/zUid";

export class SelectDictionaryStore {
  constructor() {
    makeAutoObservable(this);
  }

  wait = false;

  setWait(flag: boolean) {
    this.wait = flag;
  }

  groups: ZDictGroup[] = [];

  setGroups(list: ZDictGroup[]) {
    this.groups = list;
  }

  async init() {
    try {
      this.setWait(true);
      const resp = await rest.get(apiObjUrl("/groups"), {
        params: { groupTypeId: 1 },
      });
      const newGroups = zDictGroup.array().parse(resp.data);
      this.setGroups(newGroups);
      checkGroups(newGroups);
    } catch (e) {
      onError(e);
    } finally {
      this.setWait(false);
    }
  }

  get dictOptions(): SelectProps["options"] {
    return this.groups.map(({ name, attributes }) => ({
      title: name,
      label: name,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      options: attributes?.map(({ name, id }) => ({
        label: name,
        value: id,
        id: `dict-opt-${id}`,
      })),
    }));
  }

  value: ZUid | null = null;

  setValue(value: ZUid | null | undefined) {
    this.value = value ?? null;
  }
}

const checkGroups = (groups: ZDictGroup[]) => {
  let dblName = "";
  const usedAttrIds = new Set<ZUid>();
  groups.forEach((g) => {
    g.attributes?.forEach(({ id, name }) => {
      if (usedAttrIds.has(id)) dblName = name;
      usedAttrIds.add(id);
    });
  });
  if (dblName)
    notification.warning({
      message: t("Attention!"),
      description: `Получены некорректные данные со списком справочников. Дублируется "${dblName}". Это приводит к неправильной работе компонента выбора справочника.`,
    });
};
